import React, { MouseEvent, useState } from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import {DumpTruckFields} from "../types/fields";
import DumpTruckStatusChip from "./DumpTruckStatusChip";
import Icon from "../../../@core/components/icon";
import {ListItemIcon} from "@mui/material";
import {getDumpTruckStatusColor} from "../types/typification";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import {DumpTruckStatusOption} from "../types/dto";


interface DumpTruckStatusChipWithMenuProps {
    option: DumpTruckStatusOption;
    optionList: DumpTruckStatusOption[];
    onOptionChange: (option: DumpTruckStatusOption) => void;
}

const DumpTruckStatusChipWithMenu: React.FC<DumpTruckStatusChipWithMenuProps> = ({ option, optionList, onOptionChange, ...rest }) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [selectedOption, setSelectedOption] = useState<DumpTruckStatusOption>(option);


    const handleClick = (event: MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuItemClick = async (option: DumpTruckStatusOption) => {
        await onOptionChange(option);
        setSelectedOption(option);
        setAnchorEl(null);
    };

    return (
        <div>
            <DumpTruckStatusChip
                option={selectedOption}
                onClick={handleClick}
                icon={<ArrowDropDownIcon />}
                elevation={3}
                {...rest}
            />
            <Menu
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}
            >
                {optionList.map((option: DumpTruckStatusOption) => (
                    <MenuItem
                        key={option[DumpTruckFields.StatusCode]}
                        selected={option[DumpTruckFields.StatusCode] === selectedOption[DumpTruckFields.StatusCode]}
                        onClick={() => handleMenuItemClick(option)}
                    >
                        <ListItemIcon>
                            <Icon
                                icon='mdi:circle'
                                color={getDumpTruckStatusColor(option[DumpTruckFields.StatusCode])}
                                fontSize='1rem'
                            />
                        </ListItemIcon>
                        {option[DumpTruckFields.StatusDescription]}
                    </MenuItem>
                ))}
            </Menu>
        </div>
    );
};

export default DumpTruckStatusChipWithMenu;